// Maps page paths to friendly display names
export const getPageDisplayName = (page) => {
  const pageMap = {
    '/': 'Home Page',
    '/analytics': 'Analytics',
    '/about-us': 'About Us',
    '/ratescph': 'Rates - Copenhagen',
    '/ratesbll': 'Rates - Billund',
    '/contact-us-cp': 'Contact Us - Copenhagen',
    '/contact-us-bl': 'Contact Us - Billund',
    '/new-track-trace': 'Track & Trace',
  };
  
  return pageMap[page] || page;
};
